import { WithContext } from "../types/schema.types";
import type { Organization } from "schema-dts";

/**
 * Organization schema data interface
 */
export interface OrganizationData {
  name: string;
  url: string;
  logo: string;
  description: string;
  foundingDate: string;
  contactPoint?: {
    telephone: string;
    contactType: string;
    availableLanguage: string[];
    areaServed: string[];
  };
  sameAs?: string[];
}

/**
 * Builds Schema.org Organization structured data
 * @param organizationData - Organization information for schema generation
 * @returns Schema.org Organization JSON-LD object
 */
export function buildOrganizationSchema(
  organizationData: OrganizationData
): WithContext<Organization> {
  const organizationSchema: WithContext<Organization> = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: organizationData.name,
    url: organizationData.url,
    logo: organizationData.logo,
    description: organizationData.description,
    foundingDate: organizationData.foundingDate,
  };

  if (organizationData.contactPoint) {
    organizationSchema.contactPoint = {
      "@type": "ContactPoint",
      telephone: organizationData.contactPoint.telephone,
      contactType: organizationData.contactPoint.contactType,
      availableLanguage: organizationData.contactPoint.availableLanguage,
      areaServed: organizationData.contactPoint.areaServed,
    };
  }

  if (organizationData.sameAs && organizationData.sameAs.length > 0) {
    organizationSchema.sameAs = organizationData.sameAs;
  }

  return organizationSchema;
}
